const Helper = {
  encodeData: (data) => {
    const payload = [];

    for (const [key, value] of Object.entries(data)) {
      payload.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }

    return payload.join("&");
  },

  toggleBtn: (btn) => {
    if (btn) {
      // get aria labels
      const labelOpen = btn.dataset.ariaLabelOpen;
      const labelClose = btn.dataset.ariaLabelClose;

      // toggle aria expanded attr
      let isExpanded = btn.getAttribute("aria-expanded") === "true" || false;
      btn.setAttribute("aria-expanded", !isExpanded);

      // toggle aria labels
      if (!isExpanded) {
        btn.setAttribute("aria-label", labelClose);
      } else {
        btn.setAttribute("aria-label", labelOpen);
      }
    }
  },
};

export default Helper;
